/** Pont renderer → fichiers coffre-fort (processus principal Electron). */
export class CoffreFortFileBridge {
  private static api() {
    return window.electron;
  }

  static isAvailable(): boolean {
    return Boolean(this.api()?.coffrefortWrite);
  }

  static async getBaseDir(): Promise<string | null> {
    const res = await this.api()?.coffrefortGetBaseDir?.();
    return res?.path ?? null;
  }

  static async write(
    tenantId: string,
    docId: string,
    filename: string,
    bytes: ArrayBuffer,
  ): Promise<{ relativePath: string; size: number }> {
    const fn = this.api()?.coffrefortWrite;
    if (!fn) throw new Error('Stockage coffre-fort indisponible (hors Electron)');
    const base64 = CoffreFortFileBridge.arrayBufferToBase64(bytes);
    const res = await fn(tenantId, docId, filename, base64);
    if (!res?.ok) throw new Error('Écriture coffre-fort échouée');
    return { relativePath: res.relativePath, size: res.size };
  }

  static async read(tenantId: string, relativePath: string): Promise<ArrayBuffer> {
    const fn = this.api()?.coffrefortRead;
    if (!fn) throw new Error('Stockage coffre-fort indisponible (hors Electron)');
    const res = await fn(tenantId, relativePath);
    if (!res?.ok || !res.base64) throw new Error(res.error ?? 'Fichier introuvable');
    return CoffreFortFileBridge.base64ToArrayBuffer(res.base64);
  }

  static async delete(tenantId: string, relativePath: string): Promise<void> {
    const fn = this.api()?.coffrefortDelete;
    if (!fn) throw new Error('Stockage coffre-fort indisponible (hors Electron)');
    await fn(tenantId, relativePath);
  }

  private static arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]!);
    return btoa(binary);
  }

  private static base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
  }
}
